import {
  PaymentValidationRuleFragment,
  RuleTrait,
  TimeRuleDto,
  TimeRuleFragment,
} from '@/app/graphql/rule-engine/sdk.rule-engine';
import { Rule, RuleMap } from './types';
import { InterBankTransferOperation, OperationTypes } from '@/shared/services/payment';
import { Operations } from '@/app/graphql/payment/sdk.payment';
import { i18n } from '../../../../i18n';

export function mapRuleStringToRegexp(rules: PaymentValidationRuleFragment[]): Rule[] {
  return rules.map((rule) => {
    const regex = rule.regex || '';
    return {
      ...rule,
      regex: new RegExp(regex),
    };
  });
}

export function disableInterbankOperationsWithTimeRule(
  operations: InterBankTransferOperation[],
  timeRules: Record<Operations, TimeRuleFragment[]>,
  isToday: boolean
) {
  return operations.map((operation) => {
    const timeRule = timeRules[operation.operationCode as Operations].find(
      (item) => item.ruleTrait === RuleTrait.Default
    )!;
    const noLimit = timeRule?.fromTime === timeRule?.createDeadline;
    const info =
      isToday && !noLimit
        ? i18n.t('FORM_PAYMENT.TRANSFER.AVAILABLE_UNTIL', {
            timeFrom: timeRule?.fromTime,
            timeTo: timeRule?.createDeadline,
          })
        : '';
    const clearingLabel =
      operation.operationCode === OperationTypes.CLEARING ? i18n.t('FORM_PAYMENT.TRANSFER.MAX_AMOUNT_ONE_MILLION') : '';
    return {
      ...operation,
      disable: (isToday && !timeRule?.createIsAllowed) || false,
      info: info + clearingLabel,
    };
  });
}

export function generateTimeLimitStatus(timeRule: TimeRuleDto, isToday: boolean, isWorkingDay: boolean = true) {
  if (!timeRule) return;

  const timeFrom = timeRule.fromTime || '00:00';
  const timeTo = timeRule.createDeadline || '00:00';

  return {
    isAllowed: isWorkingDay ? (isToday ? timeRule.createIsAllowed : true) : false,
    noLimit: timeFrom === timeTo,
    timeFrom,
    timeTo,
  };
}

export function mapRulesToRuleMap(rules: Rule[], paymentRefs?: RuleTrait[]) {
  return rules.reduce((ruleMap, rule) => {
    let paymentRefRule;

    if (rule.field == 'amount' || rule.field == 'purpose') {
      if (paymentRefs?.length && !paymentRefs.includes(rule.ruleTrait)) return ruleMap;

      if (Number(paymentRefs?.length) > 1) {
        paymentRefRule = {
          ...ruleMap[rule.field],
          [rule.ruleTrait]: {
            ...rule,
          },
          field: rule.field,
        };
      }
    }

    return {
      ...ruleMap,
      [rule.field]: {
        ...(paymentRefRule || rule),
        rules: [],
      },
    };
  }, {} as RuleMap);
}
